module.exports = "https://static.energy5.com/_next/static/images/header-6ced81adb27bcc019fe2da8a50611e1c.png";